module.exports = __webpack_public_path__ + "static/media/Attic.e15ef145.glb";